import styled from 'styled-components';
import { PopoverIconMixin } from '../../mixins/components/PopoverIconMixin';
/**
 * A wrapper for [`Icon`](#/More%20components?id=icon) when used within
 * a [`Popover`](#/Dialog%20components?id=popover).
 *
 * @since 7.41.0
 */

var PopoverIcon = /*#__PURE__*/styled.div.withConfig({
  displayName: "PopoverIcon",
  componentId: "c11n-8-64-0__sc-1lz074r-0"
})(["", ""], PopoverIconMixin);
/* @component */

export default PopoverIcon;
export var StyledPopoverIcon = PopoverIcon;